import { useHistory } from 'react-router-dom'
import React from "react";
import {ButtonPrimary} from "./ButtonPrimary";
import styled from "styled-components";
import {ButtonSecondary} from "./ButtonSecondary";

// TODO: check the styles
const LinkButtonBox = styled(ButtonPrimary)`
	
`

const LinkButtonSecondaryBox = styled(ButtonSecondary)`
	
`

export  function LinkButton({
															to,
															title,
															icon,
															target,
															isButtonSecondaryView = false,
															onClick,
															...rest
}) {
	const { push } = useHistory()

	const onLinkButtonClickHandler = (event) => {
		onClick && onClick(event)
		if (/^(http|skype)/ig.test(to)){
			if (target === '_blank') window.open(to, target);
			else window.location.href = to;
			return;
		}
		push(to)
		window.scrollTo(0, 0); // Scrolls to the top-left corner
	}

	const _RenderBoxTag = isButtonSecondaryView ? LinkButtonSecondaryBox : LinkButtonBox

	return (
		<_RenderBoxTag
			{...rest}
			onClick={onLinkButtonClickHandler}
		>
			{icon}
			<span>{title}</span>
		</_RenderBoxTag>
	)
}

export function Button({children, size = Button.SIZE.DEFAULT, icon: Icon, style = Button.STYLE.GHOST_BLUE, className = '', ...rest}){
	return (
		<a {...rest} className={`btn ${size} btn-rounded ${Icon ? `btn-icon` : ``}  btn-start ${style} ${className}`}>
			{Icon && <Icon className={`stroke-current ${children ? `mr-2`:``}`} />}
			{children}
		</a>
	)
}
Button.SIZE = {
	DEFAULT: 'btn-default',
	SMALL: 'btn-sm',
	LARGE: 'btn-lg',
}
Button.STYLE = {
	GHOST_BLUE: `bg-transparent hover:bg-blue-50 text-blue-500 hover:text-blue-600`,
	RED: `bg-red-500 hover:bg-red-600 text-white`
}